import { Link } from "react-router-dom";
import { EditIcon, TrashIcon, PhoneIcon, PinIcon } from "../Iconos";

// Tarjeta de cliente: los datos de contacto y poco más.
//
// A propósito no muestra el saldo. La pantalla de la computadora la ven
// los clientes del negocio, y para revisar quién debe está la sección
// de Saldos, que además permite ordenar y filtrar.
//
// El cuerpo es un enlace real a /clientes/:id, para que funcionen el clic
// derecho, "abrir en pestaña nueva" y el botón atrás.
const ClienteCard = ({ cliente, onDelete, onEdit }) => {
  const sinPropagar = (accion) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    accion(cliente);
  };

  return (
    <article className="cliente-card">
      <div className="cliente-card-top">
        <Link to={`/clientes/${cliente.id}`} className="card-content">
          <h3>{cliente.nombre_completo}</h3>
          <p>
            <PhoneIcon /> {cliente.telefono}
          </p>
          <p>
            <PinIcon /> {cliente.direccion || "Sin dirección"}
          </p>
        </Link>

        <div className="cliente-card-actions">
          <button
            onClick={sinPropagar(onEdit)}
            className="card-action-btn edit"
            title="Editar cliente"
          >
            <EditIcon />
          </button>
          <button
            onClick={sinPropagar(onDelete)}
            className="card-action-btn delete"
            title="Eliminar cliente"
          >
            <TrashIcon />
          </button>
        </div>
      </div>
    </article>
  );
};

export default ClienteCard;
